// Chakra imports
import {
  Box,
  Portal,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
// Layout components
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Navbar from "../../components/navbar/NavbarAdmin";
import Sidebar from "../../components/sidebar/Sidebar";
import { SidebarContext } from "../../contexts/SidebarContext";
import routes from "../../routes";
import { IS_RETAILER } from "../../utils/Api";
import { actions } from "../../views/auth/slice";
// Custom Chakra theme
export default function Dashboard(props: { [x: string]: any }) {
  const { ...rest } = props;
  // states and functions
  const isRetailer = IS_RETAILER
  const [fixed] = useState(false);





  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [mini, setMini] = useState(false);
  const [hovered, setHovered] = useState(false);
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== "/admin/full-screen-maps";
  };
  const getActiveRoute = (routes: RoutesType[]): string => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items ?? []);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes: RoutesType[]): boolean => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routes[i].items ?? []);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].secondary ?? false;
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes: RoutesType[]): any => {
    return routes?.map((route: RoutesType, key: number) => {
      if (route.layout === "/admin") {
        return (
          <Route path={`${route.path}`} element={route.component} key={key} />
        );
      }
      if (route.collapse) {
        return getRoutes(route?.items ?? []);
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";
  const { onOpen } = useDisclosure();
  const bg = useColorModeValue("background.100", "background.900");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  React.useEffect(() => {
    const token = localStorage.getItem("token");
    dispatch(actions.setIsToken(token));
    if (token) {
      dispatch(
        actions.doGetProfile({
          token: token,
          callback: () => { },
        })
      );
    } else {
      navigate("/auth/login");
    }

    return () => { };
  }, [token]);

  return (
    <Box bg={bg} h="100vh" w="100vw">
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
        }}
      >
        <Sidebar
          hovered={hovered}
          setHovered={setHovered}
          mini={mini}
          routes={isRetailer === "true" ? routes?.retailerRoutes?.filter((x: any) => x.visibleSidebar) : routes?.adminRoutes?.filter((x: any) => x.visibleSidebar)}
          display="none"
          {...rest}
        />


        <Box
          float="right"
          minHeight="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          w={
            mini === false
              ? { base: "100%", xl: "calc( 100% - 290px )" }
              : mini === true && hovered === true
                ? { base: "100%", xl: "calc( 100% - 290px )" }
                : { base: "100%", xl: "calc( 100% - 120px )" }
          }
          maxWidth={
            mini === false
              ? { base: "100%", xl: "calc( 100% - 290px )" }
              : mini === true && hovered === true
                ? { base: "100%", xl: "calc( 100% - 290px )" }
                : { base: "100%", xl: "calc( 100% - 120px )" }
          }
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
        >
          <Portal>
            <Box>
              <Navbar
                hovered={hovered}
                setMini={setMini}
                mini={mini}
                onOpen={onOpen}
                logoText={"Petscio"}
                brandText={getActiveRoute(isRetailer === "true" ? routes.retailerRoutes : routes.adminRoutes)}
                secondary={getActiveNavbar(isRetailer === "true" ? routes.retailerRoutes : routes.adminRoutes)}
                theme={props.theme}
                setTheme={props.setTheme}
                fixed={fixed}
                {...rest}
              />
            </Box>
          </Portal>

          {getRoute() ? (
            <Box
              mx="auto"
              p={{ base: "20px", md: "30px" }}
              pe="20px"
              minH="100vh"
              pt="50px"
            >
              <Routes>
                {getRoutes(isRetailer === "true" ? routes.retailerRoutes : routes.adminRoutes)}
                <Route
                  path="/"
                  element={<Navigate to="/admin/dashboards" replace />}
                />
              </Routes>
            </Box>
          ) : null}
          {/* <Box>
            <Footer />
          </Box> */}
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
